import * as React from 'react';
import { ModalWindow } from '@cian/ui-kit';

import { BanksList } from './components/BanksList';
import { BuildersList } from './components/BuildersList';
import { PromoDescription } from './components/PromoDescription';

import * as styles from './PromoDetailsModal.css';
import { IPromoPopupBank, IPromoPopupBuilder, IPromoProp } from '../../types/promosPage';

interface IPromoDetailsModalProps {
  banks: IPromoPopupBank[];
  builders: IPromoPopupBuilder[];
  description?: string | null;
  features: IPromoProp[];
  logo: string;
  name: string;
  newbuildingButton?: React.ReactNode;
  onClose(): void;
}

export const PromoDetailsModal: React.FC<IPromoDetailsModalProps> = ({
  banks,
  builders,
  description,
  features,
  logo,
  name,
  newbuildingButton,
  onClose,
}) => {
  return (
    <ModalWindow open={true} onClose={onClose} width="100%" maxWidth={648}>
      <div className={styles['container']} data-testid="PromoDetailsModal">
        <div className={styles['section']}>
          <PromoDescription name={name} logo={logo} description={description} features={features} />
        </div>
        {newbuildingButton && (
          <div className={styles['section']}>
            <div className={styles['button-container']}>{newbuildingButton}</div>
          </div>
        )}
        {banks.length > 0 && (
          <div className={styles['section']}>
            <BanksList banks={banks} />
          </div>
        )}
        {builders.length > 0 && (
          <div className={styles['section']}>
            <BuildersList builders={builders} />
          </div>
        )}
      </div>
    </ModalWindow>
  );
};
